/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { ApiDemoService } from './services/api-demo/api-demo.service';
import { OutputAdapterService } from './services/output-adapter/output-adapter.service';
import { InputAdapterService } from './services/input-adapter/input-adapter.service';
import { environment } from '@environments/environment';
import { ApiService } from './services/api/api.service';
import { HttpReqService } from '@api/services/http-req/http-req.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';

export const apiServiceFactory = (
  http: HttpClient,
  outputAdapter: OutputAdapterService,
  inputAdapter: InputAdapterService,
  httpReq: HttpReqService
): ApiService => {
  if (environment.devMode && !!localStorage.getItem('useDemo')) {
    return new ApiDemoService(http, outputAdapter, inputAdapter, httpReq);
  } else {
    return new ApiService(http, outputAdapter, inputAdapter, httpReq);
  }
};

@NgModule({
  declarations: [],
  imports: [CommonModule, HttpClientModule],
  providers: [
    {
      provide: ApiService,
      useFactory: apiServiceFactory,
      deps: [
        HttpClient,
        OutputAdapterService,
        InputAdapterService,
        HttpReqService
      ]
    }
  ]
})
export class ApiModule {}
